import { apiClient } from "@/services/HttpService";

//新建用户
export function createDoc(params) {
  return apiClient.post("/ref-doc", params);
}

export function loadDoc(docId) {
  return apiClient.get(`/ref-doc/${docId}`);
}

export function fetchDocList(searchParam) {
  return apiClient.post("/ref-doc/search", searchParam);
}

export function deleteRefDoc(docId) {
  return apiClient.delete(`/ref-doc/${docId}`);
}